export type CurrencyOption = {
  code: string;
  symbol: string;
  label: string;
};

export const currencyOptions: CurrencyOption[] = [
  { code: 'USD', symbol: '$', label: '$ USD - US Dollar' },
  { code: 'CAD', symbol: '$', label: '$ CAD - Canadian Dollar' },
  { code: 'AUD', symbol: '$', label: '$ AUD - Australian Dollar' },
  { code: 'MXN', symbol: '$', label: '$ MXN - Mexican Peso' },
  { code: 'EUR', symbol: '€', label: '€ EUR - Euro' },
  { code: 'GBP', symbol: '£', label: '£ GBP - British Pound' },
];

export const getCurrencySymbol = (currencyCode?: string): string => {
  if (!currencyCode) return '$';

  return currencyOptions.find(option => option.code === currencyCode)?.symbol ?? '$';
};

export const formatCurrencyAmount = (amount: number | string, currencyCode?: string): string =>
  `${getCurrencySymbol(currencyCode)}${amount}`;
